import Share from 'ninelines-sharing';
import helpers from '../../js/helpers';

helpers.$document.on('click', '.card__button[data-social]', (e) => {
	const id = $(e.currentTarget).closest('.card').data('id');
	const url = `${location.origin + location.pathname + location.search}/share.php?id=${id}`;

	// eslint-disable-next-line default-case
	switch (e.currentTarget.dataset.social) {
		case 'facebook':
			Share.facebook(url);
			break;
		case 'vk':
			Share.vk(url);
			break;
		case 'twitter':
			Share.twitter(url);
			break;
		case 'ok':
			Share.ok(url);
			break;
		case 'telegram':
			Share.telegram(url);
			break;
	}
});
